import { render, staticRenderFns } from "./NavbarLanguage.vue?vue&type=template&id=2eb2838a&lang=pug&"
import script from "./NavbarLanguage.vue?vue&type=script&lang=js&"
export * from "./NavbarLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports